import BodyText from '../../../atoms/BodyText';
import classNames from 'classnames';
import Title from '../../../atoms/Title';
import Icon from '../../../atoms/Icon';
import * as styles from './companyProfileContactPerson.linaria';
function CompanyProfileContactPerson({ company, className, }) {
    var _a;
    const contactPerson = ((_a = company === null || company === void 0 ? void 0 : company.contactPersons) === null || _a === void 0 ? void 0 : _a.length) > 0 ? company.contactPersons[0] : null;
    return (<div className={classNames([styles.contactPersonWrapper, className])}>
      <Title size="small">Kontaktperson</Title>
      {contactPerson ? (<div className="contact-person-infor">
          <div className="infor-section">
            <BodyText tag="p" size="small" className="contact-person-name">
              {contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.name}
            </BodyText>
            <BodyText tag="p" size="small" className="contact-person-details">
              {contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.designation}
            </BodyText>
            <BodyText tag="p" size="small" className="contact-person-details">
              {contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.phone}
            </BodyText>
            <BodyText tag="p" size="small" className="contact-person-details">
              {contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.email}
            </BodyText>
          </div>
          <div className="image-section">
            {(contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.image) ? (<img alt={contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.name} src={contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.image}/>) : (<Icon icon="ContactPerson" size="stretch" strokeColor="none"/>)}
          </div>
        </div>) : (<BodyText tag="p" size="small">
          Mangler kontaktperson
        </BodyText>)}
    </div>);
}
CompanyProfileContactPerson.defaultProps = {
    className: null,
};
export default CompanyProfileContactPerson;
